// 20/07/2026 — temps de jeu réel (supervision). 45 → "45 s", 720 → "12 min",
// 7500 → "2 h 05".
export const formatPlayTime = (seconds) => {
  const s = Number(seconds);
  if (!Number.isFinite(s) || s <= 0) return '—';
  if (s < 60) return `${Math.round(s)} s`;
  const totalMinutes = Math.floor(s / 60);
  if (totalMinutes < 60) return `${totalMinutes} min`;
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  return `${h} h ${String(m).padStart(2, '0')}`;
};

export const formatMoney = (amount) => {
  return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(amount);
};

export const formatMoneyDetailed = (amount) => {
  return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);
};

export const gaugeColor = (percentage) => {
  if (percentage < 60) return '#10B981'; // green
  if (percentage <= 80) return '#F59E0B'; // orange
  return '#EF4444'; // red
};

export const gaugeColorClass = (percentage) => {
  if (percentage < 60) return 'bg-emerald-500';
  if (percentage <= 80) return 'bg-amber-500';
  return 'bg-red-500';
};

export const satisfactionColor = (percentage) => {
  if (percentage > 60) return '#10B981';
  if (percentage >= 40) return '#F59E0B';
  return '#EF4444';
};

export const satisfactionColorClass = (percentage) => {
  if (percentage > 60) return 'bg-emerald-500';
  if (percentage >= 40) return 'bg-amber-500';
  return 'bg-red-500';
};

export const severityColor = (severity) => {
  const map = { mineur: '#10B981', modéré: '#F59E0B', grave: '#EF4444', critique: '#7C3AED' };
  return map[severity] || '#6B7280';
};

export const severityBg = (severity, category) => {
  // Accidents and breakdowns always orange/red
  if (category === 'Accident' || category === 'Panne mécanique') {
    const map = { mineur: 'bg-amber-500', modéré: 'bg-orange-500', grave: 'bg-red-600', critique: 'bg-red-700' };
    return map[severity] || 'bg-red-500';
  }
  const map = { mineur: 'bg-emerald-500', modéré: 'bg-amber-500', grave: 'bg-red-500', critique: 'bg-violet-600' };
  return map[severity] || 'bg-gray-500';
};

export const calculateLoanPayment = (principal, annualRate, durationMonths) => {
  // 29/05/2026 — audit credit fix : guard against degenerate inputs
  // (zero/negative principal, zero/negative duration) that previously
  // returned NaN or Infinity and could silently corrupt the credits
  // array on edge-case quotes.
  // 04/06/2026 — also guard non-finite annualRate (NaN/undefined) that
  // legacy saves can carry on a malformed loan proposal.
  if (!Number.isFinite(principal) || principal <= 0) return 0;
  if (!Number.isFinite(durationMonths) || durationMonths <= 0) return 0;
  if (!Number.isFinite(annualRate) || annualRate < 0) return 0;
  const r = annualRate / 12;
  if (r === 0) return principal / durationMonths;
  return principal * r / (1 - Math.pow(1 + r, -durationMonths));
};

export const isWorkingDay = (day) => {
  const dayOfWeek = ((day - 1) % 7);
  return dayOfWeek < 5; // Mon-Fri
};

export const getInitials = (name) => {
  return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
};
